import React from 'react';
import Title from '@atoms/Title/Title';
import Text from '@atoms/Text/Text';
import Button from '@atoms/Button/Button';
import Section from '@atoms/Section/Section';
import TitleGroup from '@atoms/TitleGroup/TitleGroup';
import Module from '@atoms/Module/Module';
import CardWithBackground from '../Card/CardWithBackground';
import './ChapterPricing.scss';
import { Box } from '@material-ui/core';
import HeroIcon from '@atoms/HeroIcon/HeroIcon';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import CommonActionButton from './CommonActionButton';

const ChapterPricing = ({
    title,
    subtitle,
    pricingTitle,
    pricingSubtitle,
    list,
    ctaUrl,
    ctaLabel,
    desktopImage,
    desktopSharpImage,
    mobileImage,
    mobileSharpImage,
    secondaryCtaLabel,
    secondaryCtaUrl,
}) => {
    return (
        <Section container="large" spacingTop="m" className="ChapterPricing">
            <div className="ChapterPricing--wrapper">
                <div className="ChapterPricing--background">
                    <CardWithBackground
                        url={desktopImage}
                        urlSharp={desktopSharpImage}
                        mobileUrl={mobileImage}
                        mobileSharpImage={mobileSharpImage}
                        greenBackground
                    >
                        <TitleGroup
                            theme="white"
                            title={title}
                            subtitle={subtitle}
                        />
                    </CardWithBackground>
                </div>

                <Module
                    radius="giant"
                    padding="l"
                    className="ChapterPricing--pricingDetail"
                >
                    {pricingSubtitle && (
                        <Text size="s" align="center">
                            {pricingSubtitle}
                        </Text>
                    )}
                    <Title size="l" font="alt" noMargin align="center">
                        {pricingTitle}
                    </Title>
                    <Section spacingTop="s" spacingBottom="xs">
                        {list.map((item) => (
                            <Box
                                display="flex"
                                alignItems="center"
                                gridGap={16}
                                sx={{ mb: 1 }}
                            >
                                <HeroIcon theme="success" size="xs">
                                    <AiOutlineCheckCircle />
                                </HeroIcon>

                                <Title size="m" noMargin>
                                    {item.text}
                                </Title>
                            </Box>
                        ))}
                    </Section>
                    <CommonActionButton cta={{ ctaUrl, ctaLabel }} />
                    {secondaryCtaLabel && (
                        <a href={secondaryCtaUrl}>
                            <Button
                                align="center"
                                variant="naked"
                                label={secondaryCtaLabel}
                            />
                        </a>
                    )}
                </Module>
            </div>
        </Section>
    );
};

export default ChapterPricing;
